import { bool, func, string } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button as StorybookButton } from '@sunbeltrentals/sbr-global-components';
import LocationPin20 from '../../../../../../resources/images/locationpin20.svg';
import { productTileDataLocator } from '../../../addToCartTile/dataLocators';

const SelectRentalLocationDates = ({
    emptyDetailsText = '',
    emptyDetailsSubText = '',
    openEmptyLocationDateModal = () => {},
    showRatesCta = false,
    isRequestQuoteCTA = false
}) => {
    const intl = useIntl();
    return (
        <>
            {!showRatesCta ? (
                <StorybookButton
                    className="producttile__rentaldates"
                    buttonAriaLabel={emptyDetailsText}
                    onClick={openEmptyLocationDateModal}
                    data-testid={productTileDataLocator.productTile_add_rental_details}>
                    <LocationPin20 tabIndex={'-1'} aria-hidden={true} className="producttile__rentaldates-pin" />
                    <span>{emptyDetailsText}</span>
                </StorybookButton>
            ) : (
                <>
                    <div className="producttile__wrapper">
                        <StorybookButton
                            className="producttile__rentaldates"
                            buttonAriaLabel={emptyDetailsText}
                            onClick={openEmptyLocationDateModal}
                            data-testid={productTileDataLocator.productTile_add_rental_details}>
                            <span>{emptyDetailsText}</span>
                        </StorybookButton>
                        <span>&nbsp;{emptyDetailsSubText || intl.formatMessage({ id: 'pdp:enter-rentail-details-remaining-text' })}</span>
                    </div>
                    {!isRequestQuoteCTA && (
                        <StorybookButton
                            variant="block"
                            customClassName="producttile__rates-cta"
                            buttonAriaLabel={intl.formatMessage({ id: 'product-tile-rates-cta-text' })}
                            onClick={openEmptyLocationDateModal}
                            dataTestId={productTileDataLocator.get_rates_cta}>
                            {intl.formatMessage({ id: 'product-tile-rates-cta-text' })}
                        </StorybookButton>
                    )}
                </>
            )}
        </>
    );
};
export default React.memo(SelectRentalLocationDates);

SelectRentalLocationDates.propTypes = {
    emptyDetailsText: string,
    emptyDetailsSubText: string,
    openEmptyLocationDateModal: func,
    showRatesCta: bool,
    isRequestQuoteCTA: bool
};
